import moment from "moment";
import extenso from "extenso";
import { publicAxios, securedAxios } from "../lib/axios";
import urljson from "../lib/urljson";
import { build } from "../lib/masks";
import number_format from "../lib/number_format";
import { paraCentavos } from "../lib/moeda";

export default {
  namespaced: true,
  actions: {
    async gerar(context, { template, dados }) {
      try {
        const response = await publicAxios.post(
          `${process.env.VUE_APP_SERVER_URL}/relatorios/${template}`,
          dados,
          {
            responseType: "blob",
          }
        );
        return Promise.resolve(response);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    async contasReceberVendedor(context, opcoes) {
      try {
        const response = await securedAxios.get(
          `/relatorio/relatorio-contas-receber-vendedor?opcoes=${urljson(opcoes)}`
        );
        return Promise.resolve(response.data);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    async gerarDadosContasReceber1(context, opcoes) {
      try {
        const response = await securedAxios.get(
          `/relatorio/relatorio-contas-receber?opcoes=${urljson(opcoes)}`
        );
        return Promise.resolve(response.data);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    async gerarFatura({ dispatch }, id) {
      try {
        const response = await dispatch(
          "ordemMedicao/buscarFaturaPorOrdem",
          {
            CarregarContasReceber: true,
            filtros: { id_ordem: id },
          },
          { root: true }
        );
        const fatura = response.data.pop();
        fatura.ordem.cliente.enderecos2 = fatura.ordem.cliente.enderecos[0];
        fatura.ordem.cliente.enderecos2.cep = build.cep(
          fatura.ordem.cliente.enderecos2.cep
        );
        fatura.ordem.cliente.cpf_cnpj =
          fatura.ordem.cliente.tipo == "J"
            ? build.cnpj(fatura.ordem.cliente.cpf_cnpj)
            : build.cpf(fatura.ordem.cliente.cpf_cnpj);

        fatura.data_emissao = moment(fatura.data_emissao.substr(0, 10)).format(
          "DD/MM/YYYY"
        );

        fatura.valor = number_format(fatura.valor);

        fatura.valor_extenso = extenso(fatura.valor, {
          mode: "currency",
        });

        fatura.contaBancaria = "";
        for (let contasreceber of fatura.contasreceber) {
          contasreceber.data_vencimento = moment(
            contasreceber.data_vencimento.substr(0, 10)
          ).format("DD/MM/YYYY");

          fatura.videAbaixo = contasreceber.data_vencimento;

          contasreceber.valor_receber = number_format(
            contasreceber.valor_receber
          );

          if ([3, 4].indexOf(contasreceber.id_forma_pagamento) > -1) {
            // forma de pgto Depósito Bancário
            fatura.contaBancaria = "DADOS BANCÁRIOS PARA DEPÓSITO À SABER:";
            fatura.contaBancaria +=
              "<BR /> Banco " +
              contasreceber.conta_bancaria.banco.nome +
              " - " +
              contasreceber.conta_bancaria.banco.codigo;

            fatura.contaBancaria +=
              "<BR />Agência: " + contasreceber.conta_bancaria.agencia;
            fatura.contaBancaria +=
              "<BR />Conta Corrente: " + contasreceber.conta_bancaria.conta;
            fatura.contaBancaria +=
              "<BR />Favorecido: " + fatura.empresa.razao_social;
            fatura.contaBancaria += "<BR />CNPJ: " + fatura.empresa.cnpj;
          }
        }

        if (fatura.contasreceber.length > 1) {
          fatura.videAbaixo = "VIDE ABAIXO";
        }

        const ordemItens = await dispatch("ordemMedicao/carregarItens", id, {
          root: true,
        });

        fatura.periodoFatura = "";
        const datasMedicao = ordemItens.data
          .filter((item) => item.data_medicao != null)
          .map((item) => moment(item.data_medicao.substr(0, 10)))
          .filter((data) => data.isValid());

        if (datasMedicao.length > 0) {
          const primeiraMedicao = moment.min(datasMedicao);
          const ultimaMedicao = moment.max(datasMedicao);

          fatura.periodoFatura = primeiraMedicao.format("DD/MM/YYYY");
          if (!primeiraMedicao.isSame(ultimaMedicao, "day")) {
            fatura.periodoFatura += ` à ${ultimaMedicao.format("DD/MM/YYYY")}`;
          }
        }

        fatura.observacao = fatura.observacao.replaceAll("\n", "<br>");

        const rel = await dispatch("gerar", {
          template: "fatura.html",
          dados: {
            titulo: "FATURA",
            dados: { data: fatura },
          },
        });
        return Promise.resolve(rel.data);
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async gerarPreFatura({ dispatch }, id) {
      try {
        const fatura = await dispatch("ordemMedicao/carregarOrdemMedicao", id, {
          root: true,
        });
        fatura.data.cliente.enderecos2 = fatura.data.cliente.enderecos[0];
        fatura.data.data_emissao = moment(
          fatura.data.data_emissao.substr(0, 10)
        ).format("DD/MM/YYYY");

        let valorCentavos = 0;
        let descontoCentavos = paraCentavos(fatura.data.desconto);
        let valorComDescontoCentavos = descontoCentavos * -1;

        // incluir itens ======================
        const ordemItens = await dispatch("ordemMedicao/carregarItens", id, {
          root: true,
        });

        let dataAtual = new Date();
        const descMes = {
          "01": "Janeiro",
          "02": "Fevereiro",
          "03": "Março",
          "04": "Abril",
          "05": "Maio",
          "06": "Junho",
          "07": "Julho",
          "08": "Agosto",
          "09": "Setembro",
          10: "Outubro",
          11: "Novembro",
          12: "Dezembro",
        };
        if (dataAtual) {
          fatura.data.dia_atual = dataAtual.getDate();
          fatura.data.mes_atual =
            descMes[(dataAtual.getMonth() + 1).toString().padStart(2, "0")];
          fatura.data.ano_atual = dataAtual.getFullYear();
        }
        fatura.data.linhas_adicionais = 25 - ordemItens.data.length;

        fatura.data.data_inicio_medicao = "";
        fatura.data.data_fim_medicao = "";
        for (let item of ordemItens.data) {
          if (item.data_medicao != null) {
            const data = moment(
              item.data_medicao.substr(0, 10)
            );
            if (fatura.data.data_inicio_medicao == "") {
              fatura.data.data_inicio_medicao = data;
            } else if (fatura.data.data_inicio_medicao > data) {
              fatura.data.data_inicio_medicao = data;
            }


            //if (fatura.data.data_fim_medicao < item.data_medicao.substr(0, 10))
            if (fatura.data.data_fim_medicao == "") {
              fatura.data.data_fim_medicao = data;
            } else if (fatura.data.data_fim_medicao < data) {
              fatura.data.data_fim_medicao = data;
            }

            item.data_medicao = data.format(
              "DD/MM/YYYY"
            );
          }

          if (item.hora_fim > 0 && item.hora_inicio > 0) {
            let totalMedido = item.hora_fim - item.hora_inicio;
            if (totalMedido < 10)
              totalMedido = 10;

            item.total_medido = totalMedido;
          } else item.total_medido = 1;

          if (item.horas_cobrar == null) item.horas_cobrar = 1;

          const valorTotalCentavos = paraCentavos(
            item.horas_cobrar * item.valor_cobrar
          );
          const descontoItemCentavos = paraCentavos(item.desconto_item);
          const valortotal = valorTotalCentavos / 100;
          item.hora_inicio = number_format(item.hora_inicio);
          item.hora_fim = number_format(item.hora_fim);
          item.total_medido = number_format(item.total_medido);
          item.horas_cobrar = number_format(item.horas_cobrar);
          item.valor_cobrar = number_format(item.valor_cobrar);
          item.valorTotal = number_format(valortotal);

          valorCentavos += valorTotalCentavos;
          descontoCentavos += descontoItemCentavos;
          valorComDescontoCentavos +=
            valorTotalCentavos - descontoItemCentavos;
        }

        fatura.data.valor = valorCentavos / 100;
        fatura.data.desconto = descontoCentavos / 100;
        fatura.data.valor_com_desconto = valorComDescontoCentavos / 100;

        if (fatura.data.data_inicio_medicao != "") {
          fatura.data.data_inicio_medicao = fatura.data.data_inicio_medicao.format("DD/MM/YYYY");
        }
        if (fatura.data.data_fim_medicao != "") {
          fatura.data.data_fim_medicao = fatura.data.data_fim_medicao.format("DD/MM/YYYY");
        }
        fatura.data.itens = ordemItens.data;
        // =====================================
        fatura.data.valor = number_format(fatura.data.valor);
        fatura.data.desconto = number_format(fatura.data.desconto);
        fatura.data.valor_com_desconto = number_format(
          fatura.data.valor_com_desconto
        );

        fatura.data.cliente.enderecos2.cep = build.cep(
          fatura.data.cliente.enderecos2.cep
        );
        fatura.data.cliente.cpf_cnpj =
          fatura.data.cliente.tipo == "J"
            ? build.cnpj(fatura.data.cliente.cpf_cnpj)
            : build.cpf(fatura.data.cliente.cpf_cnpj);

        fatura.data.valor_extenso = extenso(fatura.data.valor, {
          mode: "currency",
        });

        const contatos = [];
        for (let contato of fatura.data.cliente.contatos) {
          if (contato.nome == "Receita federal") {
            continue;
          }
          contato.telefones = contato.telefones.map((t) => {
            t.numero = build.phone(t.numero);
            return t;
          });
          contatos.push(contato);
        }
        fatura.data.cliente.contatos = contatos;

        const rel = await dispatch("gerar", {
          template: "ordem-medicao-cliente.html",
          dados: {
            titulo: "PRE-FATURA",
            dados: { data: fatura.data },
          },
        });

        return Promise.resolve(rel.data);
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async gerarDadosVendas1(context, opcoes) {
      try {
        const response = await securedAxios.get(
          `/relatorio/relatorio-vendas?opcoes=${urljson(opcoes)}`
        );
        return Promise.resolve(response.data);
      } catch (err) {
        return Promise.reject(err);
      }
    },
  },
};
